import { supabase, withRetry } from '../lib/supabase';
import type { Database } from '../lib/database.types';

export type Lesson = Database['public']['Tables']['lessons']['Row'];

export async function getLessons(): Promise<Lesson[]> {
  return withRetry(async () => {
    const { data, error } = await supabase
      .from('lessons')
      .select('*')
      .order('order', { ascending: true });

    if (error) {
      throw error;
    }

    return data || [];
  });
}

// Função auxiliar para migrar os dados iniciais (use apenas uma vez)
export async function migrateInitialLessons(): Promise<void> {
  const initialLessons = [
    {
      title: "Configurando seu Ambiente Java",
      duration: "25:30",
      is_available: true,
      is_completed: false,
      description: "",
      video_id: "JhfLdSZvOLU",
      topics: [
        "A nova oportunidade Java",
        "Full Stack virou um problema",
        "Empresas que apostam forte em Java",
        "O jeito certo de aprender Java"
      ],
      order: 1
    },
    {
      title: "Fundamentos da Linguagem",
      duration: "45:15",
      is_available: false,
      is_completed: false,
      description: "Sintaxe básica, tipos de dados e estruturas de controle",
      video_id: "90NcVNXvT5k",
      topics: [
        "Tipos de dados primitivos",
        "Estruturas de controle",
        "Arrays e loops",
        "Funções e métodos"
      ],
      order: 2
    },
    {
      title: "Orientação a Objetos na Prática",
      duration: "55:00",
      is_available: false,
      is_completed: false,
      description: "Classes, objetos, herança e polimorfismo",
      topics: [
        "Classes e objetos",
        "Encapsulamento",
        "Herança e polimorfismo",
        "Interfaces e classes abstratas"
      ],
      order: 3
    }
  ];

  return withRetry(async () => {
    const { error } = await supabase
      .from('lessons')
      .insert(initialLessons);

    if (error) {
      throw error;
    }
  });
} 